<template>
  <v-container>
    <div class="main-title text-center">
      <SectionTitle class="d-inline-block">Como funciona na prática</SectionTitle>
      <p class="section-subtitle mt-4">
        Do toque do cliente até a cozinha, tudo dentro do ecossistema ZaperMenu.
      </p>
    </div>

    <v-row class="mt-8 steps" justify="space-between">
      <v-col
        v-for="(step, i) in steps"
        :key="i"
        cols="12"
        md="4"
        class="step-item"
      >
        <div class="step-text">
          <div class="step-badge">
            <v-icon color="white" size="26">{{ step.icon }}</v-icon>
            <span class="step-number">{{ i + 1 }}</span>
          </div>
          <h3 class="step-title">{{ step.title }}</h3>
          <p class="step-desc">{{ step.desc }}</p>
        </div>
        <v-icon v-if="i < steps.length - 1" class="icon" large>mdi-arrow-right</v-icon>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';

  export default {
    name: 'TabletHowItWorksSection',

    components: {
      SectionTitle,
    },

    data: () => ({
      steps: [
        {
          icon: 'mdi-gesture-tap-button',
          title: 'O cliente acessa o tablet na mesa',
          desc: 'O tablet já abre no seu cardápio, em modo autoatendimento.',
        },
        {
          icon: 'mdi-cart-check',
          title: 'Monta o pedido e confirma',
          desc: 'Escolhe os itens, vê fotos e sugestões de complementos e confirma o pedido.',
        },
        {
          icon: 'mdi-printer-pos',
          title: 'A cozinha recebe na hora',
          desc: 'O pedido cai na impressora, no KDS e no PDV, sem retrabalho e sem erro.',
        },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .section-subtitle {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-muted);
    max-width: 560px;
    margin: 0 auto;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .step-item {
    text-align: center;
    display: flex;
    align-items: center;

    @media (max-width: 960px) {
      flex-direction: column;
      max-width: 100% !important;
      .icon {
        transform: rotate(90deg);
        margin: 10px 0;
      }
    }
  }

  .step-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
  }

  .step-badge {
    position: relative;
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: linear-gradient(135deg, #f40612 0%, #ff6b35 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 24px rgba(244, 6, 18, 0.35);
  }

  .step-number {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #f40612;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid var(--page-bg);
  }

  .step-title {
    font-size: 17px;
    font-weight: 700;
    margin: 16px 0 8px;
    color: var(--text-primary);
  }

  .step-desc {
    font-size: 14px;
    color: var(--text-muted);
    line-height: 1.6;
    margin: 0;
    max-width: 280px;
  }

  .steps {
    @media (max-width: 960px) {
      flex-direction: column;
    }
  }
</style>
